/* eslint-disable jsx-a11y/anchor-is-valid */
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { Table } from 'antd'
import { timeEnd } from 'console';

export function Dashboard4(props: any) {
    const { dataSource } = props

    const columns = [
        {
            title: 'ลำดับ',
            dataIndex: 'no',
            key: 'no',
            width: 80
        },
        {
            title: 'คำถาม (Intent)',
            dataIndex: 'intent',
            key: 'intent',
        },
        {
            title: 'จำนวนครั้ง',
            dataIndex: 'count',
            key: 'count',
            width: 100,
            render: (text: any) => {
                return (<div style={{ textAlign: 'center' }}>{text}</div>)
            }
        },
    ];
    return (<Table
        dataSource={dataSource}
        columns={columns}
        bordered title={() => {
            return (<div style={{ textAlign: 'center' }}>5 อันดับกลุ่มคำถาม</div>)
        }}
        size="middle"
        pagination={false}
    />)

}